import { render, staticRenderFns } from "./heroSection.vue?vue&type=template&id=74e49d5d&scoped=true"
import script from "./heroSection.vue?vue&type=script&lang=ts"
export * from "./heroSection.vue?vue&type=script&lang=ts"
import style0 from "./heroSection.vue?vue&type=style&index=0&id=74e49d5d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e49d5d",
  null
  
)

export default component.exports